module.exports = __webpack_public_path__ + "img/icon-empresas.6ed0e265.svg";